<template lang="pug">
.searchHelper.followAccordionWidth.hpadding(:class="{open: mustBeShown}")
  // viewOnly to do not have js interaction for accordion
  .accordionList.viewOnly
    transition-group(name="fade", tag="div", :css="false", @before-enter="beforeEnter", @enter="enter", @leave="leave")
      .accordionList-item(v-for="(prop, index) in propositions", @mousedown="selectProposition(prop)", :key="'p' + index", :class="{selected: selectedIndex == index}")
        .header
          span(v-if="prop.explanationKey") {{$t("searchHelper." + prop.explanationKey)}}
          template(v-if="prop.explanationKey") &nbsp;&nbsp;
          span(:class="{'text-light': prop.explanationKey}") {{prop.textToShow}}  
          span.description(v-if="prop.description") {{prop.description}}
</template>
<script>
import _ from 'lodash'
import $ from 'jquery'

import {mapGetters} from 'vuex'

import searchBus from '@/components/shared/SearchBus'

export default {
  data: function () {
    return {
      shown: false,
      selectedIndex: -1,
      cacheContacts: null,
      cachePublicGroups: [],
      cacheSearchText: '',
      searchPublicGroupFn: _.debounce((function (_this) {
        return function () {
          // return api.publicOrApi({
          //   url: '/public/groups',
          //   data: {
          //     withTexts: _this.searchObject.texts
          //   }
          // }).done(function (data) {
          //   return _this.cachePublicGroups = data.publicGroups
          // })
        }
      })(this), 500)
    }
  },
  mounted () {
    searchBus.$on(searchBus.actions.KEY_DOWN, this.onKeydown)
    searchBus.$on(searchBus.actions.KEY_UP, this.onKeyup)
    searchBus.$on(searchBus.actions.KEY_ENTER, this.onKeyEnter)
    searchBus.$on(searchBus.actions.KEY_ESCAPE, this.onKeyEscape)
  },
  methods: {
    open: function () {
      return setTimeout((function (_this) {
        return function () {
          _this.shown = true
        }
      })(this), 50)
    },
    close: function () {
      return setTimeout((function (_this) {
        return function () {
          _this.shown = false
        }
      })(this), 50)
    },
    selectProposition: function (prop) {
      return this.$store.dispatch('search/selectProposition', prop).then(() => {
        setTimeout(() => {
          $('#mainSearchForm input').focus()
        }, 10)
      })
    },
    beforeEnter: function (el) {
      return $(el).hide()
    },
    enter: function (el, done) {
      return $(el).slideDown(300, done)
    },
    leave: function (el, done) {
      return $(el).slideUp(300, done)
    },
    onKeydown: function () {
      if (!this.mustBeShown) {
        return
      }
      this.selectedIndex = Math.min(this.selectedIndex + 1, this.propositions.length - 1)
    },
    onKeyup: function () {
      if (!this.mustBeShown) {
        return
      }
      this.selectedIndex = Math.max(this.selectedIndex - 1, -1)
    },
    onKeyEnter: function () {
      if (this.selectedIndex > -1) {
        return this.selectProposition(this.propositions[this.selectedIndex])
      }
    },
    onKeyEscape: function () {
      this.close()
    }
  },
  computed: {
    mustBeShown: function () {
      return this.propositions.length > 0 && this.searchOpen
    },
    contacts: function () {
      if (this.cacheContacts != null) {
        return this.cacheContacts
      }
      this.cacheContacts = []
      // return api.api('/contacts').done((function (_this) {
      //   return function (data) {
      //     return _this.cacheContacts = data.contacts
      //   }
      // })(this))
    },
    publicGroups: function () {
      if (JSON.stringify(this.searchObject) === this.cacheSearchText) {
        return this.cachePublicGroups
      }
      this.cacheSearchText = JSON.stringify(this.searchObject)
      this.cachePublicGroups = []
      this.searchPublicGroupFn()
      return this.cachePublicGroups
    },
    ...mapGetters('search', [
      'propositions',
      'searchOpen'
    ])
  },
  watch: {
    propositions () {
      this.selectedIndex = -1
    }
  }
}
</script>
<style lang='sass'>
.searchHelper 
  .accordionList-item
    white-space: nowrap
    overflow: hidden
  .description
    display: inline-block
    opacity: 0.6
    text-overflow: ellipsis
    white-space: nowrap
    font-size: 0.9em
    &:before
      margin-left: 20px
      content: ''
</style>



// WEBPACK FOOTER //
// SearchHelper.vue?a1452846